import React from 'react';
import PropTypes from 'prop-types';
import { FDDialogActions } from '@facet-wealth/design';

export const DialogActions = ({ children }) => {
  return (
    <FDDialogActions>
      {children}
    </FDDialogActions>
  );
};

DialogActions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
